import styled from 'styled-components'

import { Prefix, Title } from '~/components/Typography/styles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  position: relative;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: -20px;
  margin-right: -20px;
  width: auto;
  height: auto;
  padding: 0px 20px 20px 20px;
  overflow: hidden;
  margin-top: 19px;
`

export const DescriptionText = styled(Title)`
  font-weight: 600;
  font-size: 14px;
  line-height: 16.8px;
  color: #353535;
`
export const ChecksIndicators = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: fit-content;
  margin: auto;
  margin-top: 12px;

  span {
    font-size: 12px;
    line-height: 15px;
  }
`

export const IndicatorOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const TermsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  gap: 4px;
`

export const Text = styled(Prefix)`
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: ${({ theme }) => theme.colors.neutral.black700};
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  width: 100%;
`

export const SizeLabelInformationText = styled(Prefix)`
  line-height: 9.71px;
  font-size: 9.71px;
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
`

export const SizeLabelInformationIcon = styled.div`
  width: 28.89px;
  height: 28.89px;
  border-radius: 50%;
  line-height: 9.71px;
  font-size: 12.94px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.palette.black};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
`
